module.exports = __webpack_public_path__ + "e0106718/img/product-icon-grey.b248963c.svg";